import React from "react";
import { FiPower } from "react-icons/fi";
import { FaUser } from "react-icons/fa";
import { useGlobalContext } from "../../hooks/context";

const Logout = () => {
  const { userLogout } = useGlobalContext();
  return (
    <div>
      <div className="flex justify-between mt-10 sm:px-8">
        <div className="mx-auto">
          <img className="h-32 mx-auto" src="/logo/pair-logo.png" alt="" />
          <h3 className="mt-4 text-2xl font-medium">Please Logout Here</h3>
          <div className="mt-5 ml-16 flex items-center gap-x-5">
            <button className="p-1.5  bg-gray-400 rounded-full">
              <FaUser size={20} />
            </button>
            <div className="w-[1px] h-5 border-r-2 border-gray-500" />
            <button className="text-rose-600" onClick={userLogout}>
              <FiPower size={28} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;
